import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Asterisk = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 12 11"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M5.99995 0L5.99995 11M2.11086 1.61091L9.88904 9.38909M2.11091 9.38914L9.88909 1.61096M0.5 5.50007L11.5 5.50007" />
    </svg>
  ),
)
Asterisk.displayName = 'Asterisk'
Asterisk.defaultProps = {
  width: 12,
  height: 11,
}

export default Asterisk
